import {injectable} from "inversify";
import Scene = Phaser.Scene;
import PlayerStore from "@/store/player";
import {PlayerMarker} from "@/store/player/types";
import ListenerManager from "@/managers/listener-manager";
import CU from "@/utils/c-u";

@injectable()
export class LawServiceBeeline {

    public async open(
        scene: Scene,
        canvas: HTMLCanvasElement,
    ) {

        CU.blockCanvas(scene);
        ListenerManager.callBeelineRegisterCallback();
    }

    private haveMarker(marker: String): Boolean {
        return PlayerStore.getPlayer()!.playerMarkers.some((m: PlayerMarker) => m.playerMarker == marker);
    }
}